export const PRIMARY_COLOR = "#164f9f";
export const SECONDARY_COLOR = "#cccccc";
export const TERTIARY_COLOR = "#0063af";
export const QUATERNARY_COLOR = "#e6e6e6";
export const QUINARY_COLOR = "#808080";
export const SENARY_COLOR = "#ff931e";
export const SEPTANARY_COLOR = "#f12e26";

//export const COLORS = [PRIMARY_COLOR, SECONDARY_COLOR];
